export enum PillsFilterType {
	EMPTY, // placeholder since this is 0 item index
	BLK,
	TPM,
	CUSTOM,
	NONE // no filtering
}
